/** @module @category Extension */ import { isEqual } from "lodash-es";
import { configExtensionStore } from "@openmrs/esm-config";
import { createGlobalStore, getGlobalStore } from "@openmrs/esm-state";
const extensionInternalStore = createGlobalStore('extensionsInternal', {
    slots: {},
    extensions: {}
});
/**
 * This gets the extension system's internal store. It is subject
 * to change radically and without warning. It should not be used
 * outside esm-core.
 * @internal
 */ export const getExtensionInternalStore = ()=>getGlobalStore('extensionsInternal', {
        slots: {},
        extensions: {}
    });
/** @internal */ export function updateInternalExtensionStore(updater) {
    // This is a function that updates the internal extension store.
    const state = extensionInternalStore.getState();
    const newState = updater(state);
    if (newState !== state) {
        extensionInternalStore.setState(newState);
    }
}
/**
 * This returns a store that modules can use to get information about the
 * state of the extension system.
 */ export const getExtensionStore = ()=>getGlobalStore('extensions', {
        slots: {}
    });
/**
 * esm-config maintains its own store of the extension information it needs
 * to generate extension configs. We keep it updated based on what's in
 * `extensionStore`.
 */ updateConfigExtensionStore(extensionInternalStore.getState());
extensionInternalStore.subscribe(updateConfigExtensionStore);
function updateConfigExtensionStore(extensionState) {
    const configExtensionRecords = [];
    for (let extensionInfo of Object.values(extensionState.extensions)){
        for (let instance of extensionInfo.instances){
            configExtensionRecords.push({
                slotModuleName: instance.slotModuleName,
                extensionModuleName: extensionInfo.moduleName,
                slotName: instance.slotName,
                extensionId: instance.id
            });
        }
    }
    if (!isEqual(configExtensionStore.getState().mountedExtensions, configExtensionRecords)) {
        configExtensionStore.setState({
            mountedExtensions: configExtensionRecords
        });
    }
}
